module.exports = __webpack_public_path__ + "assets/img/third_user_s.293beacf.svg";